import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, string_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { effect } from "../Hooks/ClickOutside.js";
import { classNames } from "../../Utils.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { Size, getMaterialIconBySize } from "../../ViewUtils.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import "../../../src/Components/Popover/Popover.scss";


export const commonIcons = {
    ExclamationMark: "error",
    Info: "info",
    QuestionMark: "help",
    Warning: "warning",
};

export class PopoverProps extends Record {
    constructor(Content, MaterialIcon) {
        super();
        this.Content = Content;
        this.MaterialIcon = MaterialIcon;
    }
}

export function PopoverProps$reflection() {
    return record_type("Components.Popover.PopoverProps", [], PopoverProps, () => [["Content", class_type("Fable.React.ReactElement")], ["MaterialIcon", string_type]]);
}

export const render = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2;
    const popoverOpenState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        popoverOpenState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    const popoverClasses = classNames(ofArray([["popover-container__text", true], ["popover-container__text--show", popoverOpenState[0]]]));
    const children_4 = [react.createElement("div", {
        className: popoverClasses,
    }, props.Content), (children_2 = [getMaterialIconBySize(props.MaterialIcon, new Size(1))], react.createElement("div", {
        className: "d-flex",
        onClick: (_arg) => {
            popoverOpenState[1]((value) => (!value));
        },
    }, ...children_2))];
    return react.createElement("span", {
        className: "popover-container",
        ref: containerRef,
    }, ...children_4);
}, "Popover", Helpers_equalsButFunctions, void 0, "render", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Popover\\Popover.fs", 44);

